import Vue from 'vue';

// Vendors
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
// import { fab } from '@fortawesome/free-brand-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import BootstrapVue from 'bootstrap-vue';
import VueClipboard from 'vue-clipboard2';

// Set up fontawesome
library.add(fas);
library.add(far);

Vue.component('fa', FontAwesomeIcon);
Vue.use(BootstrapVue);
Vue.use(VueClipboard);
